<template>
  <div class="container" v-if="$i18n.locale === 'es'">
    <div class="terms" style="width: 80%; margin: auto; margin-top: 150px">
      <h1 class="text-center text-capitalize">
        CONDICIONES DE USO - FLIXLATINO
      </h1>
      <p>
        <strong>Resumen:</strong>
      </p>
      <p>
        ¡Bienvenido a FlixLatino! Somos un servicio por subscripción que provee
        acceso a películas, programas de televisión y demás contenido audio
        visual ("películas y espectáculos") transmitidos a través del Internet a
        televisores, ordenadores, u otros aparatos conectados al Internet
        (aparatos programados para recibir FlixLatino).
      </p>
      <p>
        Estas <em>Condiciones de Uso</em> reglamentan el uso del servicio
        FlixLatino, que a su vez pertenece a Somos Next, LLC. Cuando en estas
        <em>Condiciones de Uso</em>, aparece uno de los siguientes vocablos,
        "servicios de FlixLatino", "nuestro servicio", o "el servicio" significa
        el servicio ofrecido por Somos Next, LLC, conocido como FlixLatino, el
        cual se usa para descubrir y disfrutar películas y espectáculos,
        incluyendo funciones, sitios web, e interfaz para el usuario, al igual
        que todo el contenido y software asociado con nuestro servicio.
      </p>
      <p>
        El servicio de FlixLatino es limitado para residentes de los Estados
        Unidos de América únicamente. Si es residente de los Estados Unidos de
        América (incluso de sus posesiones y territorios), deberá estar de
        acuerdo con el Acuerdo de Arbitraje descrito en la Sección 15, el cual
        provee para que se resuelva cualquier disputa relacionada con FlixLatino
        [con excepción de aquello que podrá radicarse en la Corte para
        Reclamaciones de Menor Cuantía (Small Claims Court)] utilizando
        Arbitraje.
      </p>
      <p>
        Favor tomar nota que estas <em>Condiciones de Uso</em> incluyen
        hipervínculos a los que sólo tendrá acceso a través de nuestro sitio
        web, de forma que si está revisando estas
        <em>Condiciones de Uso</em> utilizando un aparato preparado para
        transmitir FlixLatino, podrá requerírsele que visite
      </p>
      <p>
        <a href="http://www.flixlatino.com/termsofuse"
          >www.flixlatino.com/termsofuse</a
        >
        para revisar los hipervínculos.
      </p>
      <p>
        1. <strong>Aceptación de las <em>Condiciones de Uso</em></strong>
      </p>
      <p>
        a. Estas <em>Condiciones de Uso</em>, que incluyen nuestro
        <em>Reglamento Sobre Privacidad</em>, regulan el uso del servicio
        FlixLatino. Al usar, visitar o navegar FlixLatino, acepta y está de
        acuerdo con las <em>Condiciones de Uso</em>. Si usted no está de acuerdo
        con las <em>Condiciones de Uso</em>, no deberá utilizar el servicio
        FlixLatino.
      </p>
      <p>
        b. EL servicio FlixLatino es provisto por Somos Next, LLC o una de sus
        compañías afiliadas o relacionadas. Favor cotejar como el proveedor de
        servicios el cual puede cambiar estas Condiciones de Uso de tiempo en
        tiempo.
      </p>
      <p>
        2. <strong>Cambios a las Condiciones de Uso</strong>: FlixLatino, podrá
        de tiempo en tiempo, enmendar las <em>Condiciones de Uso</em>, incluso
        el <em>Reglamento Sobre Privacidad</em>. Tales revisiones serán
        efectivas inmediatamente; siempre y cuando que para los usuarios
        existentes, las revisiones serían efectivas a los treinta días de haber
        sido notificadas.
      </p>
      <p>
        3. <strong>Privacidad.</strong> Información personal que podría
        identificar a la persona, se rige por el
        <em>Reglamento Sobre Privacidad</em> (<a
          href="http://www.flixlatino.com/privacypolicy"
          >www.flixlatino.com/privacypolicy</a
        >), cuyas disposiciones se incorporan a estas
        <em>Condiciones de Uso</em>. Favor revisar nuestra política de
        privacidad para estar al tanto de nuestras prácticas.
      </p>
      <p>
        4. <strong>Preferencias en Cuanto a la Comunicación</strong>. Al
        utilizar el servicio FlixLatino, usted da su consentimiento a recibir
        comunicaciones electrónicas enviadas por FlixLatino en relación a su
        cuenta. El propósito de estas comunicaciones podría conllevar el envío
        de mensajes electrónicos a la dirección electrónica que proveyó al
        registrarse o fijar mensajes en el servicio FlixLatino GO o bajo la
        página designada como "Su Cuenta". Podrá también incluir notificaciones
        sobre su cuenta (por ejemplo, pagos autorizados, cambio de contraseña o
        métodos de pago, mensajes electrónicos de confirmación u otra
        información transaccional) que sea parte de su relación con FlixLatino.
        También da su consentimiento a que cualquier notificación, acuerdo,
        divulgación, u otra comunicación que le enviemos electrónicamente
        cumplirá también con cualquier requisito legal, incluso de que el mismo
        sea por escrito. Deberá mantener copia de comunicaciones electrónicas,
        bien sea copiando el mensaje en papel o grabándolo electrónicamente.
        También da su consentimiento a recibir otro tipo de comunicaciones de
        parte nuestra, así como un boletín informativo sobre presentaciones y
        contenido nuevo de FlixLatino, ofertas especiales, anuncios
        promocionales y encuestas de usuarios, a través de emails u otros
        medios. Si en algún momento no desea recibir comunicaciones no
        transaccionales, sencillamente puede ir a "Preferencias E-mails" en el
        enlace "Su Cuenta" en nuestro sitio web (<a
          href="http://www.flixlatino.com/myaccount"
          >www.flixlatino.com/myaccount</a
        >) para manejar sus comunicaciones FlixLatino. Favor revisar nuestro
        <em>Reglamento Sobre Privacidad</em>, visitando (<a
          href="http://www.flixlatino.com/privacypolicy"
          >www.flixlatino.com/privacypolicy</a
        >) para más detalles sobre comunicaciones de mercadeo.
      </p>
      <p>
        5.
        <strong
          >Membrecía, Pruebas Libre de Costo, Facturación, y
          Cancelación.</strong
        >
      </p>
      <p>
        <strong> </strong>
      </p>
      <p>
        <strong> a. Membresía:</strong>
      </p>
      <p>
        <strong> </strong>
      </p>
      <p>
        <strong> </strong>
        i.<strong> Membresía Continua. </strong>Su membresía en FlixLatino, la
        cual podrá
      </p>
      <p>
        comenzar con una Prueba Libre de Costo, continuará en efecto de mes a
        mes de no ser o hasta que usted cancele tal membresía o nosotros la
        demos por terminada. Para utilizar los servicios de FlixLatino, deberá
        tener acceso al Internet y tendrá que proveernos con un método de pago
        corriente, válido y aceptable (que podrá ser actualizado de tiempo en
        tiempo, "Método de Pago"). Le facturaremos un cargo mensual de membresía
        a su Método de Pago. Deberá cancelar su membresía antes de que ésta se
        renueve mensualmente para así evitar ser facturado por ese mes a su
        Método de Pago.
      </p>
      <p>
        ii. <strong>Distintos Tipos de Membresía</strong>. Podremos ofrecer un
        número de distintos planes de membresía, incluso planes promocionales
        especiales o distintos tipos de membresía con ciertas condiciones y
        limitaciones. Cualquier término materialmente distinto al descrito en
        estas <em>Condiciones de Uso</em>, será divulgado al registrarse o en
        otra comunicación informativa. Podrá encontrar detalles sobre su
        membresía en FlixLatino si visita nuestro sitio web y clic el enlace "Su
        Cuenta". Algunas membresías promocionales pueden ofrecerse por terceros
        en conjunto con sus propios productos o servicios. En tal caso, no somos
        responsables por los productos o servicios ofrecidos por tales terceros.
      </p>
      <p>b. <strong>Prueba Libre de Costo. </strong></p>
      <p>
        <strong> </strong>
      </p>
      <p>
        i. Su membresía en FlixLatino podrá comenzar con una Prueba Libre de
        Costo. El período de tal Prueba Libre de Costo, durará un mes, o por el
        período de tiempo especificado al registrarse. Si fuera en combinación
        con otras ofertas, algunas restricciones podrían aplicar. Estas Pruebas
        Libre de Costo serán únicamente para nuevos miembros y algunos
        individuos que fueron miembros anteriormente. FlixLatino se reserva el
        derecho, en su absoluta discreción, a determinar si una persona es o no
        elegible para recibir la Prueba Libre de Costo.
      </p>
      <p>
        ii. Comenzaremos a facturarle el costo de membresía mensual a su Método
        de Pago una vez finalice el período de la Prueba Libre de Costo, siempre
        y cuando usted no optó por cancelar el servicio antes de terminar el
        Período Libre de Costo. Para revisar los detalles específicos de su
        membresía, incluso el precio de su membresía mensual y la fecha en que
        termina su Prueba Libre de Costo, visite nuestro sitio web y clic el
        enlace "Detalles Sobre Facturación" en la página "Su Cuenta".
      </p>
      <p>
        <strong> </strong>
      </p>
      <p>
        <strong> </strong>
        iii. No recibirá una notificación de que el período de Prueba Libre de
        Costo ha finalizado o que la porción del período en que debe pagar por
        el servicio ha comenzado.
      </p>
      <p>
        OPRIMA CLIC AL ENLACE DE "SU CUENTA" EN LA PARTE SUPERIOR DE CUALQUIER
        PAGINA WEB DE FLIXLATINO (
        <a href="http://www.flixlatino.com/">www.flixlatino.com</a>) PARA LOGRAR
        ACCESO A LAS INSTRUCCIONES PARA CANCELAR SU MEMBRESIA. Continuaremos
        facturando su Método de Pago mensualmente hasta tanto usted cancele la
        membresía.
      </p>
      <p>c. <strong>Facturación</strong></p>
      <p>
        i. <strong>Facturación Recurrente</strong>. Al comenzar su membresía en
        FlixLatino una vez provista la información de pago, usted autoriza a
        FlixLatino a facturar al Método de Pago el costo de su membresía para
        recibir los servicios una vez concluido el periodo promocional. Nos
        autoriza a cobrar a su Método de Pago un pago mensual (u otro pago
        periódico) al precio corriente más cualquier otro cargo que haya
        incurrido en referencia a su uso del servicio FlixLatino. Usted reconoce
        que la cantidad facturada cada mes podrá variar de un mes a otro (de un
        semestre a otro o de un año a otro) por distintas razones que pueden
        incluir cantidades de ofertas promocionales, incluyendo la redención de
        tarjetas de regalo, redención de códigos promocionales, y/o cambios al
        actual plan, o por haber añadido un nuevo plan. Usted nos autoriza a
        cobrarle a su Método de Pago por tales variadas cantidades, que podrán
        cobrarse mensualmente o en uno o más cargos.
      </p>
      <p>
        ii. <strong>Cambios en Precio</strong>. Nos reservamos el derecho a
        hacer ajustes a los precios por servicios o el precio de cualquier
        porción de un servicio, en cualquier modo y a cualquier momento que así
        lo determinemos a nuestra discreción. De no ser provisto expresamente en
        estas <em>Condiciones de Uso</em>, cualquier cambio en su servicio podrá
        tomar efecto una vez se le notifique por correo electrónico.
      </p>
      <p>
        iii. <strong>Ciclo de Facturación. </strong>El costo de membresía se
        facturará al principio de la porción pagada de su membresía y cada mes
        subsiguiente<strong> </strong>hasta que usted cancele tal membresía.
        Automáticamente le cobramos cada mes a su Método de Pago, el día
        correspondiente en el calendario, al día en que comenzó su membresía
        paga. Los cargos por membresía se consideran devengados al recibirse el
        pago de los mismos. Nos reservamos el derecho de cambiar la fecha de
        cobro, especialmente si su Método de Pago no ha efectuado el pago. En el
        caso en que su membresía paga comenzó en un día que no ocurre en un mes
        en particular, podríamos escoger cualquier otro día del mes que
        consideremos apropiado para cobrar la membresía. Por ejemplo, si comenzó
        la membresía de FlixLatino o empezó a ser un miembro pago de FlixLatino
        el 31 de enero, su próximo pago en toda probabilidad sea facturado el 28
        de febrero y en tal día se le cobraría a su Método de Pago. La fecha en
        que le tocaría renovar su membresía podría variar debido a cambios en su
        membresía. Visite nuestro sitio web y haga clic al enlace "Vea Detalles
        sobre Facturación" bajo "Su Cuenta" para ver la fecha de comienzo de su
        próximo período de renovación. Podríamos adelantarle a su Método de
        Pagos sobre cargos próximos relacionado con su membresía o con el
        servicio. El vocablo "Facturación" en estas
        <em>Condiciones de Uso</em> significa un cargo, débito o cuando un pago
        se efectúa según sea el caso, a través de su Método de Pago. De no ser
        que se indique lo contrario, mensual, o mensualmente se refiere a su
        ciclo de facturación.
      </p>
      <p>
        iv. <strong>No Habrán Reembolsos. </strong>Pagos una vez efectuados no
        serán reembolsables y no existirán reembolsos o créditos por períodos
        parcialmente utilizados. Seguido a cualquier cancelación, se tendrá
        acceso al servicio hasta finalizar el periodo de facturación. A
        cualquier momento y por cualquier razón, se podrán proveer reembolsos,
        descuento u otra consideración a algunos o todos los miembros
        (créditos). La cantidad y forma de tales créditos y la decisión de
        otorgarlos siempre será una decisión entera y absolutamente a nuestra
        discreción. La otorgación de un crédito en un momento dado, no le da
        derecho a créditos futuros por similares motivos, y bajo ninguna
        circunstancia nos obliga a otorgarlos en el futuro.
      </p>
      <p>
        v. <strong>Métodos de Pago.</strong> Podrá editar la información
        contenida en "Métodos de Pago", visitando nuestro sitio web y clic al
        enlace "Su Cuenta", disponible en la parte superior del sitio web de
        FlixLatino. Si un pago no se logra cobrar, debido a que se pasó la fecha
        de expiración, o un pago haya sido denegado o por falta de fondos o por
        cualquier otra razón y usted deja de editar la información en su Método
        de Pago o deja de proceder a cancelar su cuenta (Refiérase a
        "Cancelaciones" a continuación) usted permanecerá responsable por
        cualquier cantidad no cobrada y usted nos autoriza a continuar
        facturando al Método de Pago, por si ésta resulta editada. Esto podría
        causar un cambio en la fecha de facturación. En el caso de ciertos
        Métodos de Pago, el emisor de su Método de Pago podría cobrarle una
        tarifa por transacción extranjera u otros cargos. Consulte con su emisor
        de crédito para más detalles.
      </p>
      <p>
        vi. <strong>Cancelación. </strong>Podrá cancelar su membresía en
        FlixLatino en cualquier momento y continuará teniendo acceso al servicio
        FlixLatino hasta el final del ciclo mensual. No proveemos reembolsos o
        créditos por periodos de membresía parciales o por películas o programas
        de televisión no vistos. Para cancelar, vaya a "Su Cuenta" en el sitio
        web and siga las instrucciones para cancelar. Si cancela su membresía,
        su cuenta cerrará automáticamente al finalizar su período de facturación
        actual. Para ver cuando su cuenta cerrará, clic "Detalles Facturación"
        en la página "Su Cuenta". Si se registró en FlixLatino utilizando su
        cuenta con un tercero como Método de Pago y desea cancelar su membresía
        en FlixLatino podrá hacerlo en cualquier momento, incluso durante el
        período de prueba libre de costo, aunque posiblemente tenga que ser a
        través de la cuenta con el tercero, visitando la cuenta con éste y
        deshabilitando "auto renew" u oprimiendo "darse de baja" (unsubscribe)
        del servicio a través del cual obtuvo los servicios de FlixLatino. Podrá
        también obtener información sobre facturación de su membresía FlixLatino
        visitando su cuenta con el tercero en cuestión.
      </p>
      <p>6. <strong>Servicio FlixLatino</strong></p>
      <p>
        a. Deberá haber cumplido al menos 18 años, o la edad de mayoría en su
        estado o territorio, para ser miembro del servicio de FlixLatino. No
        obstante individuos de menos de 18 años o de la edad de mayoría, podrán
        utilizar el servicio, pero únicamente con la participación de un
        padre/madre o tutor legal y bajo la cuenta de esta persona y sujeto a
        estas <em>Condiciones de Uso</em>.
      </p>
      <p>
        b. El servicio de FlixLatino, como también cualquier contenido visto a
        través de nuestro servicio, será únicamente para su uso personal, no
        comercial. Durante el tiempo de vigencia de su membresía FlixLatino, le
        proveemos una licencia limitada, no-exclusiva, no-transferible para
        obtener acceso al servicio FlixLatino y para ver películas y
        espectáculos a través del servicio basado en transferencia continua para
        tal propósito. Con excepción de la anterior licencia limitada, no se le
        transfiere al miembro de FlixLatino derecho alguno, título o interés.
        Igualmente se compromete a no usar este servicio para propósitos de
        representaciones públicas.
      </p>
      <p>
        c. Podrá ver una película o espectáculo a través de FlixLatino,
        primordialmente en el país en que estableció su cuenta y únicamente en
        localizaciones geográficas donde ofrecemos nuestro servicio y hemos
        obtenido la licencia para la película o espectáculo. El contenido
        disponible para ser visto puede variar en distintas localizaciones
        geográficas. FlixLatino utilizará tecnologías que pueden verificar su
        localización. EL NÚMERO DE APARATOS EN QUE PODRÁ USAR EL SERVICIO
        SIMULTÁNEAMENTE ES LIMITADO. Visite en el página "Mi Cuenta" bajo cambio
        de planes para verificar el número de aparatos que están autorizado a
        usar simultáneamente. El número de aparatos a utilizarse y las
        transferencias continuas simultaneas podrán cambiar de tiempo en tiempo
        a nuestra discreción.
      </p>
      <p>
        d. Estamos continuamente actualizando el servicio que ofrece FlixLatino,
        incluyendo la biblioteca de contenido. Además, constantemente llevamos a
        cabo pruebas de varios aspectos del servicio, incluso nuestro sitio web,
        el interfaz con nuestro usuarios, los niveles de servicio, los planes
        que se ofrecen y facilidades promocionales, la disponibilidad de
        películas y espectáculos, y la entrega y precios del producto. Nos
        reservamos el derecho de, y al usar el servicio usted está de acuerdo
        que, podemos incluirle o excluirle de participar en estas pruebas sin
        notificación previa. Nos reservamos el derecho a nuestra única y
        absoluta discreción, de llevar a cabo cambios de tiempo en tiempo y sin
        notificación en la forma en que ofrecemos nuestro servicio y como se
        opera el mismo.
      </p>
      <p>
        e. Usted se compromete a usar el servicio ofrecido por FlixLatino,
        incluso todas las aplicaciones y funcionalidades asociadas con tal
        servicio, de acuerdo con todas las leyes, reglas y reglamentos
        aplicables y cualquier restricción de uso y contenido incluido en éstas.
        Se compromete a no archivar, bajar (con excepción del cache necesario
        para uso personal), reproducir, distribuir, modificar, exhibir,
        publicar, licenciar, crear obras derivativas de éste, ofrecer a la
        venta, o utilizar (con excepción de lo expresamente permitido en estas
        <em>Condiciones de Uso</em>) el contenido e información incluida u
        obtenida de o a través de los servicios de
      </p>
      <p>
        FlixLatino, sin primero obtener autorización por escrito de FlixLatino y
        sus licenciantes. Está de acuerdo además de no eludir, eliminar,
        alterar, de-activar, degradar o frustrar cualquier protección de
        contenido instalado en el servicio FlixLatino; usar cualquier robot,
        <em>spider, scraper, </em>u otro medio autómata para lograr acceso al
        servicio FlixLatino; descompilar, utilizar ingeniería inversa o
        desensamblar el software u otro producto o procedimiento accesible a
        través del servicio FlixLatino; instalar un código o producto o
        manipular el contenido del servicio de FlixLatino; o utilizar minería de
        data, captación de data o métodos de extracción de data. Además se
        compromete a no subir, postear, email, o de cualquier otra forma enviar
        o transmitir material designado a interrumpir, destruir o limitar la
        funcionalidad de cualquier software o hardware o equipo de
        telecomunicaciones asociado con el servicio de FlixLatino, incluso virus
        de software o cualquier otro código, archivo o programa.
      </p>
      <p>
        f. La disponibilidad de películas y espectáculos que podrá ver cambiará
        de tiempo en tiempo y de país en país. La calidad de la exposición de
        películas y espectáculos podrá variar de ordenador en ordenador, de
        aparato en aparato, y podrá verse afectado por una variedad de factores,
        como la localización, el ancho de banda disponible, y/o la velocidad de
        su conexión de Internet. La disponibilidad de HD está sujeta al servicio
        de Internet y la capacidad del aparato. No todo el contenido está
        disponible en HD y no todos los planes le permiten recibir contenido en
        HD. Una capacidad de bajar contenido de por lo menos 5 Mbps por
        transmisión se recomienda para recibir contenido HD, que se define como
        720p o mejor. Usted es responsable del pago de todo cargo por acceso al
        Internet. Favor contactar su proveedor de Internet para información
        sobre posibles cargos por el uso del Internet. FlixLatino no hace
        representaciones ni da garantías sobre la calidad de la recepción en su
        monitor. El tiempo que toma para comenzar a ver una película o
        espectáculo variará basado en varios factores, incluyendo su
        localización, ancho de banda al momento, la película o espectáculo que
        escogió y la configuración del aparato que está programado para recibir
        FlixLatino.
      </p>
      <p>
        g. El software para transmitir FlixLatino se desarrolló por o para
        FlixLatino y se diseñó para permitir la transmisión del contenido de
        FlixLatino a través de aparatos programados para transmitir FlixLatino.
        Este software podrá variar dependiendo del aparato y el medio y la
        funcionalidad la cual podrá ser diferente entre aparatos. AL UTILIZAR
        NUESTRO SERVICIO, USTED ACEPTA AND ACUERDA RECIBIR, SIN SUBSIGUIENTES
        NOTIFICACIONES O SEÑALES, VERSIONES ACTUALIZADAS DEL SOFTWARE DE
        FLIXLATINO Y DE TERCEROS AFILIADOS. SI NO ACEPTA ESTOS TÉRMINOS, NO
        UTILICE NUESTRO SERVICIO. NO NOS RESPONSABILIZAMOS O DE OTRA FORMA
        GARANTIZAMOS EL FUNCIONAMIENTO DE ESTOS APARATOS, INCLUSO LA
        COMPATIBILIDAD DE LOS APARATOS CON NUESTRO SERVICIO. Al utilizar nuestro
        servicio, usted se compromete a únicamente considerar la entidad que
        manufacturó y/o le vendió su aparato para resolver cualquier asunto
        relacionado a su aparato y su compatibilidad con el servicio de
        FlixLatino GO. Si usted vende, pierde o le roban su aparato programado
        para transmitir FlixLatino favor de de-activar este aparato. Si deja de
        cerrar la sesión o de-activar el aparato, usuarios subsiguientes podrían
        lograr acceso a FlixLatino utilizando su cuenta y podrían obtener alguna
        de la información de su cuenta. Para de-activar un aparato, siga las
        instrucciones en la página "Su Cuenta" en nuestro sitio web.
      </p>
      <p>
        h. Podemos terminar o restringir su uso de nuestro servicio, sin
        compensación o notificación, si usted está, o sospechamos que está, (i)
        violando cualesquiera de estas <em>Condiciones de Uso</em> o (ii) está
        involucrado en uso ilegal o impropio del servicio.
      </p>
      <p>
        i. Los miembros de FlixLatino deberán tener por lo menos 18 años de
        edad. Aquellos miembros de FlixLatino que son padres o madres, serán las
        personas responsables en decidir qué contenido, si alguno, les deben
        permitir a sus hijos ver. FlixLatino les provee clasificaciones
        recomendatorias indicando para que edades es apropiado el contenido de
        un programa o espectáculo.
      </p>
      <p>7. <strong>Contraseñas y Acceso a su Cuenta </strong></p>
      <p>
        a. El socio quien crea una cuenta FlixLatino y quien es también dueño
        del Método de Pago, se le conoce como el Dueño de la Cuenta. El Dueño de
        la Cuenta tiene acceso y control sobre la cuenta FlixLatino. EL Dueño de
        la Cuenta ejerce control a través del uso de su contraseña y por lo
        tanto, para mantener control exclusivo, el Dueño de la Cuenta no deberá
        revelar la contraseña a ninguna persona. Además, si el Dueño de la
        Cuenta desea prohibir que otros se pongan en contacto con el
        Departamento de Servicio al Cliente de FlixLatino y de esa forma
        potencialmente alterar el control del Dueño de la Cuenta, el Dueño de la
        Cuenta no deberá revelar los detalles sobre el Método de Pago (ej. Los
        últimos cuatro dígitos de su tarjeta de crédito o débito o su dirección
        electrónica si usa PayPal) asociado con su cuenta. Usted es responsable
        de actualizar y mantener la veracidad y precisión de la información que
        nos proveyó relacionada con su cuenta.
      </p>
      <p>
        b. Para poder brindarle fácil acceso a su cuenta y asistirle en como
        mejor administrar el servicio FlixLatino utilizamos tecnología que nos
        permite identificarle como el Dueño de la Cuenta y ofrecerle acceso
        directo a su cuenta sin requerir que escriba su contraseña u otra forma
        de identificación cuando visite el servicio de FlixLatino, lo que
        incluye el obtener acceso utilizando aparatos programados para
        FlixLatino o el sitio web.
      </p>
      <p>
        c. Deberá estar alerto de cualquier comunicación solicitando que someta
        su tarjeta de crédito u otra información de su cuenta. Al proveer
        información como respuesta a este tipo de comunicación podrá resultar en
        robo de su identidad. Siempre que desee tener acceso a su información
        sensitiva, vaya directamente al sitio web de FlixLatino y no lo haga a
        través de un hipervínculo en un email u otra comunicación electrónica,
        aunque ésta aparente ser oficial. FlixLatino se reserva el derecho a
        poner en suspenso una cuenta en cualquier momento, con o sin
        notificación al miembro de FlixLatino, para así protegerse y a sus
        socios de lo que estima podría ser actividad fraudulenta. FlixLatino no
        se obliga a dar un crédito o descuento a una membresía por suspensiones
        a la cuenta que fuesen puestas bien sea por un representante de
        FlixLatino o por el proceso automatizado de FlixLatino.
      </p>
      <p>
        8.
        <strong>Descargo de Garantía y Limitaciones de Responsabilidad</strong>.
      </p>
      <p>
        a. EL SERVICIO DE FLIXLATINO Y TODO EL CONTENIDO Y SOFTWARE ASOCIADO CON
        EL MISMO, O CUALQUIER OTRA APLICACIÓN O FUNCIONALIDAD ASOCIADA CON EL
        SERVICIO FLIXLATINO, SE PROVEEN "COMO ES" (AS IS) Y CUANDO DISPONIBLE
        (AS AVAILABLE) CON TODAS SUS FALTAS Y SIN GARANTÍA DE NINGUNA CLASE.
        FLIXLATINO NO GARANTIZA, REPRESENTA O PROMETE QUE SU USO DEL SERVICIO DE
        FLIXLATINO
      </p>
      <p>
        SERÁ SIN INTERRUPCIONES O SIN ERRORES. FLIXLATINO ESPECÍFICAMENTE
        DESCARGA RESPONSABILIDAD EN CUANTO AL USO DE APLICACIONES, EL USO DE
        APARATOS PROGRAMADOS PARA RECIBIR FLIXLATINO Y EL SOFTWARE DE
        FLIXLATINO, INCLUSO LA COMPATIBILIDAD CONTINUA CON NUESTRO SERVICIO.
      </p>
      <p>
        b. HASTA DONDE SEA PERMITIDO BAJO LAS LEYES APLICABLES, EN NINGÚN CASO
        FLIXLATINO, SUS SUBSIDIARIAS, O NINGUNO DE SUS ACCIONISTAS, DIRECTORES,
        OFICIALES, EMPLEADOS O LICENCIADORES RESPONDERÁN A USTED (MANCOMUNADA O
        SOLIDARIAMENTE) POR DAÑOS PERSONALES O ESPECIALES, INCIDENTALES,
        INDIRECTOS O CONSECUENTES DE NINGUNA CLASE, O DE CUALQUIER OTRO DAÑO.
      </p>
      <p>
        c. ALGUNAS JURISDICCIONES NO PERMITEN LA EXCLUSIÓN DE CIERTAS GARANTÍAS
        O LIMITACIONES O LA EXCLUSIÓN DE RESPONSABILIDAD POR CIERTO TIPO DE
        DAÑOS. POR LO TANTO, LA ANTERIOR LIMITACIÓN EN ESTA SECCIÓN PODRÍA NO
        SER APLICABLE A USTED. DERECHOS ESTATUTARIOS SI APLICAN.
      </p>
      <p>
        d. NADA EN ESTAS <em>CONDICIONES DE USO</em> AFECTARÁN LOS DERECHOS
        ESTATUTARIOS QUE NO SE PUEDEN RENUNCIAR Y LE APLICAN A USTED. Si alguna
        provisión o provisiones en estas <em>Condiciones de Uso </em>se
        encontraran ser invalidas, ilegales o no ejecutable, las restantes
        provisiones se mantendrán en pleno vigor.
      </p>
      <p>9. <strong>Pruebas Gratis y Promociones.</strong></p>
      <p>
        a. En ciertas jurisdicciones, las tarjetas de regalo para el servicio de
        FlixLatino podrán estar disponibles para la venta al publico en negocios
        o sitios web operados por terceros y podrán ser redimidos en nuestro
        sitio web, utilizando el enlace "Crea una Cuenta", designando el código
        promocional. De tiempo en tiempo, otros tipos de códigos promocionales
        podrán ser disponibles, incluso aquellos que forman parte de la
        promoción de un tercero. Los códigos promocionales podrán ser redimidos
        de la forma que se especifica en la promoción. Tarjetas de regalo y
        códigos promocionales podrán ser usados solo una vez, y no podrán ser
        redimidos por efectivo pero si se podrán usar en combinación con otras
        ofertas, incluyendo una oferta gratis, sujeto a ciertas restricciones
        que serán determinadas por FlixLatino a su discreción. Si recibe un
        código promocional a través de una oferta de un tercero, ciertas
        condiciones adicionales podrían aplicar.
      </p>
      <p>
        b. El servicio de FlixLatino se podrá ofrecer como una prueba libre de
        costo por un periodo limitado de tiempo (suscripción de prueba). La
        duración de la suscripción de prueba se especificará en la oferta al
        registrarse. Las suscripciones de prueba serán únicamente para nuevos
        suscriptores de los servicios de FlixLatino, de no especificarse lo
        contrario. Estas <em>Condiciones de Uso</em> aplican a cualquier
        Suscripción de Prueba, de no especificarse lo contrario.
      </p>
      <p>
        c. Al momento de registrarse para la Suscripción de Prueba, deberá
        proveer un Método de Pago válido para así utilizar el servicio de
        FlixLatino durante el periodo de prueba. No se le cobrará cantidad
        alguna al Método de Pago durante el periodo de tiempo en que dura la
        Suscripción de Prueba.
      </p>
      <p>
        d. AL EXPIRAR EL PERIODO DE LA SUSCRIPCIÓN DE PRUEBA, EL COSTO DE LA
        SUSCRIPCIÓN SE LE COBRARÁ AL MÉTODO DE PAGO, DE NO SER QUE CANCELARA
        OPORTUNAMENTE LA SUSCRIPCIÓN DE PRUEBA. DEBERÁ TOMAR NOTA DE QUE NO
        RECIBIRÁ NOTIFICACIÓN DE QUE SU SUSCRIPCIÓN DE PRUEBA ESTÁ PRÓXIMA A
        EXPIRAR O QUE YA EXPIRÓ. Para más detalles sobre su Suscripción de
        Prueba, incluso la fecha en que termina la misma, favor visitar la
        página "Mi Cuenta" en el sitio web de FlixLatino
      </p>
      <p>
        (<a href="http://www.flixlatino.com/myaccount"
          >www.flixlatino.com/myaccount</a
        >) para obtener la información más reciente que se encuentra en nuestro
        records o de lo contrario podrá comunicarse con su Proveedor de
        Suscripciones directamente.
      </p>
      <p>
        e. No se darán reembolsos, ajustes ni se aplicarán protecciones de
        precios al Costo de Suscripción si comenzara un nuevo descuento o
        promoción después de haberse registrado para los servicios de
        FlixLatino. Nuevos clientes podrán aprovecharse una sola vez de
        cualquier promoción para nuevos clientes. Los requisitos necesarios para
        poder participar de una promoción se publicarán cada vez que una
        promoción es presentada. Como una condición de estas
        <em>Condiciones de Uso</em>, usted se compromete a no registrarse
        múltiples veces para la misma oferta promocional, utilizando distintos
        nombres, direcciones, direcciones electrónicas o por otros medios. Una
        acción de esta índole constituirá una violación a las
        <em>Condiciones de Uso</em> y podrá ser causa suficiente para dar por
        terminada su Cuenta Registrada.
      </p>
      <p>10. <strong>Propiedad Intelectual</strong></p>
      <p>
        a. <strong>Derecho de Autor</strong> (Copyright). El servicio
        FlixLatino, incluso el contenido provisto por FlixLatino, es protegido
        por las leyes de derecho de autor, derecho de secretos de la industria,
        y otras leyes de propiedad intelectual y o de tratados.
      </p>
      <p>
        b. <strong>Trademark. </strong>FlixLatino es una marca registrada de
        Somos Next, LLC.
      </p>
      <p>11. <strong>Leyes Aplicables</strong></p>
      <p>
        a. En relación a todos los miembros de FlixLatino, estas
        <em>Condiciones de Uso</em> se regirán por y se interpretarán según las
        leyes del estado de Florida, Estados Unidos de América. sin atención a
        las provisiones sobre conflictos de leyes.
      </p>
      <p>
        b. Usted podrá además tener derecho a recibir los beneficios de ciertas
        leyes en protección del consumidor vigentes en su jurisdicción.
      </p>
      <p>
        12. <strong>Programas/aplicaciones. </strong>Podrá encontrar
        programas/aplicaciones, [incluyendo y sin limitación, sitios web,
        aparatos, software u otros servicios de software] en adelante
        "aplicaciones" que interactúan con el servicio FlixLatino. Estas
        aplicaciones podrán importar data relacionada a su cuenta FlixLatino y a
        sus actividades y de otra forma recoger data sobre su persona. Estas
        aplicaciones se proveen únicamente para su conveniencia y FlixLatino no
        se hace responsable por las aplicaciones. Los dueños o los que operan
        estas aplicaciones son terceros que no están relacionados a, o
        auspiciados por, FlixLatino y posiblemente no están autorizados para el
        uso con nuestro servicio en todos los países. El uso de una aplicación
        es a la opción y riesgo del usuario.
      </p>
      <p>13. <strong>Hipervínculos entre Sitios de Terceros</strong></p>
      <p>
        a. Nuestro servicio podrá enlazarle a otros sitios en el Internet,
        incluso y sin limitación, sitios controlados o que nuestros proveedores
        son dueños. Estos sitios podrán contener información o contenido que
        algunas personas consideren inapropiado u ofensivo. Estos otros sitios
        no están bajo el control de FlixLatino y usted está consiente (bien sean
        o no estos sitios afiliados de algún modo con FlixLatino o sus
        proveedores) que FlixLatino no es responsable por la precisión, el
        cumplimiento con los derechos de autor, legalidad, decencia, o cualquier
        otro aspecto del contenido de dichos sitios. El incluir uno de estos
        enlaces no implica que FlixLatino endosa tal sitio o que tiene alguna
        asociación con sus operadores.
      </p>
      <p>
        b. FlixLatino no puede asegurar que usted estará satisfecho con ningún
        producto o servicio que compra de un sitio controlado por terceros que
        tenga un enlace a o de nuestro servicio. No estamos en la obligación de
        revisar de antemano la información, productos o servicios suministrados
        por terceros (colectivamente "Contenido de Terceros"), pero sí tenemos
        el derecho de rehusar postear o editar "Contenido de Terceros". Nos
        reservamos el derecho de remover "Contenido de Terceros" por cualquier
        razón, pero no seremos responsables por dejar de remover o por una
        tardanza en hacerlo. FlixLatino no hace representaciones o garantías en
        cuanto a la seguridad de cualquier información (incluso, y sin
        limitación, información relacionada con tarjetas de crédito y otra
        información personal) que se le solicite por un tercero y usted renuncia
        irrevocablemente cualquier responsabilidad nuestra con respecto a estos
        sitios. Le exhortamos lleve a cabo cualquier investigación que crea
        necesaria o apropiada antes de proceder con cualquier transacción en la
        red con cualquiera de estos terceros.
      </p>
      <p>
        c. Cualquier área del servicio al que se obtiene acceso a través de un
        servicio de la red que pertenece a un tercero es sujeto a las reglas,
        políticas y guías del servicio propietario en la red de este tercero.
      </p>
      <p>14. <strong>Uso de Información Suministrada</strong></p>
      <p>
        <strong> </strong>
      </p>
      <p>
        <strong> </strong>
        FlixLatino está en la libertad de utilizar cualquier comentario,
        información, idea, concepto, crítica o técnica u otro material enviado
        por usted en una comunicación a nosotros ("Comentarios"), incluso sus
        respuestas a cuestionarios o a través de "<em>posteos" </em>al servicio
        de FlixLatino, incluyendo el sitio web de FlixLatino y cualquier
        interfaz de los usuarios, a través del mundo y en perpetuidad sin más
        compensación, reconocimiento, o pago por cualquier propósito, incluso,
        pero sin limitación, para el desarrollo, manufactura, y mercadeo de
        productos y para crear, modificar, o mejorar el servicio de FlixLatino.
        Además usted se compromete a no exigir ningunos derechos morales en
        cuanto a los "Comentarios" al extremo permitido por la ley aplicable.
        Favor tomar nota que FlixLatino no acepta material o ideas no
        solicitadas para películas o espectáculos y no será responsable por una
        similitud, de cualquier contenido o programas en cualquier medio, a
        materiales o ideas transmitidas a FlixLatino. De usted enviarnos
        materiales o ideas no solicitadas, lo hace con el pleno conocimiento que
        no se le proveerá compensación alguna de ningún tipo y renuncia a
        cualquier reclamación en contra de
      </p>
      <p>
        FlixLatino y/o Somos Next, LLC y sus afiliadas, en relación al uso de
        este material o ideas, aunque el material o idea usada sea
        sustancialmente similar al material o idea que usted envió.
      </p>
      <p>
        15. <strong>Apoyo al Cliente. </strong> Encontrará más información sobre
        nuestros servicios y su utilización, visitando el Centro de Ayuda de
        FlixLatino (<a href="http://www.flixlatino.com/helpcenter"
          >www.flixlatino.com/helpcenter</a
        >). Igualmente nos puede visitar si requiere asistencia con su cuenta.
        En el caso que exista un conflicto entre estas
        <em>Condiciones de Uso</em> y la información provista por Apoyo al
        Cliente u otra porción de nuestro sitio web, estas
        <em>Condiciones de Uso</em> prevalecerán.
      </p>
      <p>16. <strong>Acuerdo de Arbitraje</strong>.</p>
      <p>
        a. Usted y FlixLatino acuerdan que las <em>Condiciones de Uso</em> y el
        <em>Acuerdo de</em> <em>Arbitraje</em> obligan que cualquier disputa,
        reclamación o controversia que surja de, o esté relacionada de cualquier
        forma a los servicios de FlixLatino, se determinará a través de
        arbitraje obligatorio o en la Corte Para Reclamaciones de Menor Cuantía.
        El Arbitraje es menos formal que la litigación en una corte. El
        Arbitraje utiliza un arbitro neutral en vez de un juez o jurado, permite
        descubrimiento de prueba más limitado que en una corte y provee para
        revisión más limitada que en la corte. Usted se compromete que al estar
        de acuerdo con estas <em>Condiciones de Uso</em>, la Ley de Arbitraje
        Federal va a regir en la interpretación y ejecución de esta disposición
        y que tanto usted como FlixLatino están renunciando al derecho de un
        litigio ante jurado o de participar en una acción de clase.
      </p>
      <p>
        b. Si usted decide someter una disputa a arbitraje o radicar en la Corte
        Para Reclamaciones de Menor Cuantía, tendrá que primero enviar por
        correo certificado a FlixLatino, una notificación por escrito de su
        reclamación. Esta notificación FlixLatino deberá dirigirse a: General
        Counsel, Somos Next, 2601 S. Bayshore Drive, Suite 1250, Miami, FL 33133
        ("Dirección para Notificaciones"). Si FlixLatino inicia Arbitraje en
        contra suya, le enviará una notificación por escrito a la dirección
        electrónica que utilizó al registrar su membresía. La Notificación, bien
        sea iniciada por usted o por FlixLatino, deberá: (a) describir la
        naturaleza y base para la reclamación o disputa; (b) incluir el remedio
        específico que se busca ("Demanda"). Si FlixLatino y usted no llegan a
        un acuerdo para resolver la reclamación dentro de 30 días después de
        haberse recibido la Notificación, usted o FlixLatino puede comenzar el
        procedimiento de arbitraje o radicar la reclamación en la Corte Para
        Reclamaciones de Menor Cuantía.
      </p>
      <p>
        c. Usted puede bajar y copiar una forma de notificación y una forma para
        iniciar arbitraje en <a href="http://www.adr.org/">www.adr.org</a>. Si
        se requiere el pago de un arancel de radicación, luego de que FlixLatino
        reciba la notificación en la Dirección para Notificaciones informando
        que usted ha comenzado arbitraje, FlixLatino, sin demora, le reembolsará
        el arancel, de no ser que la reclamación es por más de US$10,000.00, en
        cual caso el arancel va por su cuenta.
      </p>
      <p>
        d. El Arbitraje se rige por las <em>Reglas de Arbitraje Comercial</em> y
        los
        <em
          >Procesos Suplementarios para Disputas Relacionadas con
          Consumidores</em
        >
        (colectivamente las Reglas AAA) de la Asociación Americana de Arbitraje,
        como modificada por este acuerdo y se administrará por la AAA. Las
        Reglas y Formas están disponibles en la red
        <a href="http://www.adr.org/">www.adr.org</a> o llamando al AAA a
        1-800-778-7879 o solicitando las mismas escribiendo a la Dirección Para
        Notificaciones. El Arbitro estará obligado por los términos de este
        Acuerdo. Todos los asuntos lo decidiré el Arbitro, incluso asuntos
        relacionados con el ámbito y exigibilidad de este Acuerdo de Arbitraje.
        De no ser que usted y FlixLatino decidan lo contrario, las vistas de
        arbitraje se llevarán a cabo en Miami, Florida.
      </p>
      <p>
        e. Si su reclamación es por US$10,000.00 o menos, nosotros acordamos que
        usted podrá elegir si el arbitraje se conducirá únicamente a base de los
        documentos sometidos al arbitro, a través de una vista telefónica, o por
        lo contrario a base de una vista en persona según se establece en las
        Reglas del AAA. Sin tener en cuenta el modo en que el arbitraje se
        conduzca, el arbitro emitirá una decisión razonable, escrita, suficiente
        para explicar los hallazgos y conclusiones en que se basa su fallo. Si
        el arbitro emite un fallo a su favor que es mayor al valor de la última
        oferta de transacción por escrito que le ofreció FlixLatino antes de que
        se eligiera el Arbitro (o si FlixLatino no le hiciera una oferta de
        transacción antes del arbitraje), entonces, FlixLatinole pagará la
        cantidad otorgada por el Arbitro o $1,000 cual sea la cantidad mayor.
        Con excepción de lo aquí expresado, el pago del arancel de radicación,
        los gastos administrativos y los honorarios del arbitro se regirán por
        las Reglas del AAA.
      </p>
      <p>
        f. USTED Y FLIXLATINO ACUERDAN QUE CADA UNO PODRÁ TRAER RECLAMACIONES EN
        CONTRA DEL OTRO SÓLO EN SU CARÁCTER INDIVIDUAL Y NO COMO DEMANDANTE O
        MIEMBRO DE UNA CLASE EN UN PROCESO DE UNA SUPUESTA CLASE O COMO
        REPRESENTANTE DE UNA CLASE. Más aun, de usted y FlixLatino no estar de
        acuerdo a lo contrario, el Arbitro no podrá consolidar más de una
        reclamación con su reclamación, y no podrá presidir en ningún proceso
        representativo o de clase. Si esta provisión se hallara no ejecutable,
        entonces esta provisión de arbitraje será nula en su totalidad. EL
        arbitro podrá conceder un fallo declarativo o un interdicto únicamente a
        favor de la parte que solicita el remedio y sólo hasta lo necesario para
        proveer el remedio requerido que cumpla con la reclamación individual de
        la parte.
      </p>
      <p>
        17. <strong>Sobrevivencia.</strong> Si alguna provisión o provisiones de
        estas <em>Condiciones de Uso</em> se declaran inválidas, ilegales, o no
        ejecutables, la validez, legalidad y el poder de ejecutar las demás
        provisiones permanecerá en pleno vigor.
      </p>
      <p>
        18. <strong>Uso en Estados Unidos de América Únicamente.</strong> El
        servicio y/o el sitio web de FlixLatino se crearon con intención de ser
        vistos dentro del área de servicio de FlixLatino. El uso de tecnología
        para disimular su localización o evitar que FlixLatino pueda determinar
        la misma, está prohibido. Deberá tomar nota que FlixLatino puede
        utilizar tecnología para verificar su localización geográfica.
        FlixLatino no asegura que materiales u otro contenido en el servicio de
        FlixLatino y/o en el sitio web son apropiados o están disponibles fuera
        de los Estado Unidos de América. Al usar el servicio de FlixLatino y al
        someter información personal que lo identifica, bien sea al registrarse,
        o subsiguientemente, usted da su consentimiento a que dicha información
        sea transferida, procesada y mantenida en los Estados Unidos de América,
        sujeto a las leyes aplicables de este país.
      </p>
    </div>
  </div>
  <div class="container" v-else>
    <div class="terms" style="width: 80%; margin: auto; margin-top: 150px">
      <h1 class="text-center text-capitalize">FlixLatino Terms of Use</h1>
      <p>
        <strong>Overview:</strong>
      </p>
      <p>
        Welcome to FlixLatino! We are a subscription service that provides our
        members with access to motion pictures, television and other
        audio-visual content ("movies &amp; shows") streamed over the Internet
        to certain Internet-connected TV's, computers and other devices
        ("FlixLatino ready devices").
      </p>
      These Terms of Use govern your use of Somos Next, LLC’s FlixLatino
      service. As used in these Terms of Use, "FlixLatino service," "our
      service" or "the service" means the service provided by Somos Next, LLC
      known as FlixLatino for discovering and watching movies &amp; shows,
      including all features and functionalities, website, and user interfaces,
      as well as all content and software associated with our service.
      <p></p>
      <p>
        If you are a resident of the United States (including its possessions
        and territories), you agree to the Arbitration Agreement and class
        action waiver described in Section 15 to resolve any disputes related to
        FlixLatino (except for matters that may be taken to small claims court).
      </p>
      <p>
        Please note that these Terms of Use include hyperlinks that may be
        accessed only through our website, so if you are reviewing these Terms
        of Use through certain FlixLatino ready devices, you may need to visit
        www.flixlatino.com/termsofuse to review these hyperlinked terms.
      </p>
      <p>1.Acceptance of Terms of Use</p>
      <p>
        a.These Terms of Use, which include our Privacy Policy
        (www.flixlatino.com/privacypolicy) govern your use of the FlixLatino
        service. By using, visiting, or browsing the FlixLatino service, you
        accept and agree to these Terms of Use. If you do not agree to these
        Terms of Use, do not use the FlixLatino service.
      </p>
      <p>
        b.The FlixLatino service is provided by Somos Next, LLC, or one of its
        affiliated companies. Check back as the service provider may change from
        time to time.
      </p>
      <p>
        2.Changes to Terms of Use. FlixLatino may, from time to time, change
        these Terms of Use, including the Privacy Policy. Such revisions shall
        be effective immediately; provided, however, for existing members, such
        revisions shall, unless otherwise stated, be effective 30 days after
        posting.
      </p>
      <p>
        3.Privacy. Personally identifying information is subject to our Privacy
        Policy
      </p>
      <p>
        (www.flixlatino.com/privacypolicy), the terms of which are incorporated
        herein. Please review our Privacy Policy to understand our practices.
      </p>
      <p>
        4.Communication Preferences. By using the FlixLatino service, you
        consent to receiving electronic communications from FlixLatino relating
        to your account. These communications may involve sending emails to your
        email address provided during registration, or posting communications on
        the FlixLatino service, or in the "Your Account" page and will include
        notices about your account (e.g., payment authorizations, change in
        password or Payment Method, confirmation e-mails and other transactional
        information) and are part of your relationship with FlixLatino. You
        agree that any notices, agreements, disclosures or other communications
        that we send to you electronically will satisfy any legal communication
        requirements, including that such communications be in writing. You
        should maintain copies of electronic communications by printing a paper
        copy or saving an electronic copy. You also consent to receiving certain
        other communications from us, such as newsletters about new FlixLatino
        features and content, special offers, promotional announcements and
        customer surveys via email or other methods. If you no longer want to
      </p>
      <p>1</p>
      <p>
        receive certain non-transactional communications, simply go to the
        "Email preferences" link on the "Your Account" page of our website
        (www.flixlatino.com/myaccount) to manage your FlixLatino communications.
        Please review our Privacy Policy (www.flixlatino.com/privacypolicy) for
        further detail on our marketing communications.
      </p>
      <p>5.Membership, Free Trials, Billing and Cancellation</p>
      <p>a.Membership</p>
      <p>
        i.Ongoing Membership. Your FlixLatino membership, which may start with a
        free trial, will continue month-to-month unless and until you cancel
        your membership or we terminate it. You must have Internet access and
        provide us with a current, valid, accepted method of payment (as such
        may be updated from time to time, "Payment Method") to use the
        FlixLatino service. We will bill the monthly membership fee to your
        Payment Method. You must cancel your membership before it renews each
        month in order to avoid billing of the next month's membership fees to
        your Payment Method.
      </p>
      <p>
        ii.Differing Memberships. We may offer a number of membership plans,
        including special promotional plans or memberships with differing
        conditions and limitations. Any materially different terms from those
        described in these Terms of Use will be disclosed at your sign-up or in
        other communications made available to you. You can find specific
        details regarding your membership with FlixLatino by visiting our
        website and clicking on the "Your Account" link. Some promotional
        memberships are offered by third parties in conjunction with the
        provision of their own products and services. We are not responsible for
        the products and services provided by such third parties. We reserve the
        right to modify, terminate or otherwise amend our offered membership
        plans.
      </p>
      <p>b.Free Trials</p>
      <p>
        i.Your FlixLatino membership may start with a free trial. The free trial
        period of your membership lasts for one month, or as otherwise specified
        during sign-up. For combinations with other offers, restrictions may
        apply. Free trials are for new and certain former members only.
        FlixLatino reserves the right, in its absolute discretion, to determine
        your free trial eligibility.
      </p>
      <p>
        ii.We will begin billing your Payment Method for monthly membership fees
        at the end of the free trial period of your membership unless you cancel
        prior to the end of the free trial period. To view the specific details
        of your membership, including monthly membership price and end date of
        your free trial period, visit our website and click the "View billing
        details" link on the "Your Account" page. We may authorize your Payment
        Method through various methods, including authorizing it up to
        approximately one month of service as soon as you register. In some
        instances, your available balance or credit limit may be reduced to
        reflect the authorization during your free trial period.
      </p>
      <p>
        iii.You will not receive a notice from us that your free trial period
        has ended or that the paying portion of your membership has begun. CLICK
        THE "YOUR ACCOUNT" LINK AT THE TOP OF ANY FLIXLATINO WEB PAGE
        (www.flixlatino.com) TO FIND CANCELLATION INSTRUCTIONS. We will continue
        to bill your Payment Method on a monthly basis for your membership fee
        until you cancel.
      </p>
      <p>c.Billing</p>
      <p>
        i.Recurring Billing. By starting your FlixLatino membership and
        providing FlixLatino with your payment information, you authorize
        FlixLatino to bill your membership fee for our service to the designated
        Payment Method after the conclusion of any promotional period. You
        authorize us
      </p>
      <p>2</p>
      <p>
        to charge you a monthly (or other periodic) membership fee at the then
        current rate, and any other charges you may incur in connection with
        your use of the FlixLatino service to your Payment Method. You
        acknowledge that the amount billed each period may vary from month to
        month (quarter to quarter or year to year) for reasons that may include
        differing amounts due to promotional offers, including gift card
        redemption and promotional code redemption, and/or changing or adding a
        plan, and you authorize us to charge your Payment Method for such
        varying amounts, which may be billed monthly in one or more charges.
      </p>
      <p>
        ii.Price Change. We reserve the rights to adjust pricing for our service
        or any components thereof in any manner and at any time as we may
        determine in our sole and absolute discretion. Except as otherwise
        expressly provided for in these Terms of Use, any price changes to your
        service will take effect following email notice to you.
      </p>
      <p>
        iii.Billing Cycle. The membership fee for our service will be billed at
        the beginning of the paying portion of your membership and each month
        thereafter unless and until you cancel your membership. We automatically
        bill your Payment Method each month on the calendar day corresponding to
        the commencement of your paying membership. Membership fees are fully
        earned upon payment. We reserve the right to change the timing of our
        billing, in particular, as indicated below, if your Payment Method has
        not successfully settled. In the event your paying membership began on a
        day not contained in a given month, we may bill your Payment Method on a
        day in the applicable month or such other day as we deem appropriate.
        For example, if you started your FlixLatino membership or became a
        paying member on January 31st, your next payment date is likely to be
        February 28th, and your Payment Method would be billed on that date.
        Your renewal date may change due to changes in your Membership. Visit
        our website and click on the "View billing details" link on the "Your
        Account" page to see the commencement date for your next renewal period.
        We may authorize your Payment Method in anticipation of membership or
        service-related charges. As used in these Terms of Use, "billing" shall
        indicate a charge, debit or other payment clearance, as applicable,
        against your Payment Method. Unless otherwise stated differently, month
        or monthly refers to your billing cycle.
      </p>
      <p>
        iv.No Refunds. PAYMENTS ARE NONREFUNDABLE AND THERE ARE NO REFUNDS OR
        CREDITS FOR PARTIALLY USED PERIODS. Following any cancellation, however,
        you will continue to have access to the service through the end of your
        current billing period. At any time, and for any reason, we may provide
        a refund, discount, or other consideration to some or all of our members
        ("credits"). The amount and form of such credits, and the decision to
        provide them, are at our sole and absolute discretion. The provision of
        credits in one instance does not entitle you to credits in the future
        for similar instances, nor does it obligate us to provide credits in the
        future, under any circumstance.
      </p>
      <p>
        v.Payment Methods. You may edit your Payment Method information by
        visiting our website and clicking on the "Your Account" link, available
        at the top of the pages of the FlixLatino website. If a payment is not
        successfully settled, due to expiration, insufficient funds, or
        otherwise, and you do not edit your Payment Method information or cancel
        your account (see, "Cancellation" below), you remain responsible for any
        uncollected amounts and authorize us to continue billing the Payment
        Method, as it may be updated. This may result in a change to your
        payment billing dates. For certain Payment Methods, the issuer of your
        Payment Method may charge you a foreign transaction fee or other
        charges. Check with your Payment Method service provider for details.
      </p>
      <p>
        vi.Cancellation. You may cancel your FlixLatino membership at any time,
        and you will continue to have access to the FlixLatino service through
        the end of your monthly billing period.
      </p>
      <p>
        WE DO NOT PROVIDE REFUNDS OR CREDITS FOR ANY PARTIAL-MONTH MEMBERSHIP
        PERIODS OR UNWATCHED MOVIES OR TV SHOWS. To cancel, go to the "Your
        Account" page on our website and follow the instructions for
        cancellation. If you cancel your membership, your account will
        automatically close at the end of your current billing period. To see
        when your account will close, click "View billing details" on the "Your
        Account" page. If you signed up for FlixLatino using your account with a
        third
      </p>
      <p>3</p>
      <p>
        party as a Payment Method, and wish to cancel your FlixLatino membership
        at any time, including during your free trial, you may need to do so
        through such third party, including by visiting your account with the
        applicable third party and turning off auto-renew, or unsubscribing
        from, the FlixLatino service through that third party. You may also find
        billing information about your FlixLatino membership by visiting your
        account with the applicable third party.
      </p>
      <p>6.FlixLatino Service</p>
      <p>
        a.You must be 18 years of age, or the age of majority in your state or
        territory, to become a member of the FlixLatino service. Individuals
        under the age of 18, or applicable age of majority, may utilize the
        service only with the involvement of a parent or legal guardian, under
        such person's account and otherwise subject to these Terms of Use.
      </p>
      <p>
        b.The FlixLatino service, and any content viewed through our service,
        are for your personal and non-commercial use only. During your
        FlixLatino membership, we grant you a limited, non- exclusive,
        non-transferable, license to access the FlixLatino service and view
        movies and shows through the service on a streaming-only basis for that
        purpose. Except for the foregoing limited license, no right, title or
        interest shall be transferred to you. You agree not to use the service
        for public performances.
      </p>
      <p>
        c.You may view a movie or show through the FlixLatino service primarily
        within the country in which you have established your account and only
        in geographic locations where we offer our service and have licensed
        such movie or show. The content that may be available to watch will vary
        by geographic location. FlixLatino will use technologies to verify your
        geographic location. THE NUMBER OF DEVICES ON WHICH YOU MAY
        SIMULTANEOUSLY WATCH IS LIMITED. Go to the change plan information in
        the "Your Account" page to see the number of devices on which you may
        simultaneously watch. The number of devices available for use and the
        simultaneous streams may change from time to time at our discretion.
      </p>
      <p>
        d.We continually update the FlixLatino service, including the content
        library. In addition, we continually test various aspects of our service
        including our website, user interfaces, service levels, plans, and
        promotional features, availability of movie and shows, delivery and
        pricing. We reserve the right to, and by using our service you agree
        that we may, include you in or exclude you from these tests without
        notice. We reserve the right in our sole and absolute discretion to make
        changes from time to time and without notice in how we offer and operate
        our service.
      </p>
      <p>
        e.You agree to use the FlixLatino service, including all features and
        functionalities associated therewith, in accordance with all applicable
        laws, rules and regulations, or other restrictions on use of the service
        or content therein. You agree not to archive, download (other than
        through caching necessary for personal use), reproduce, distribute,
        modify, display, perform, publish, license, create derivative works
        from, offer for sale, or use (except as explicitly authorized in these
        Terms of Use) content and information contained on or obtained from or
        through the FlixLatino service without express written permission from
        FlixLatino and its licensors. You also agree not to: circumvent, remove,
        alter, deactivate, degrade or thwart any of the content protections in
        the FlixLatino service; use any robot, spider, scraper or other
        automated means to access the FlixLatino service; decompile, reverse
        engineer or disassemble any software or other products or processes
        accessible through the FlixLatino service; insert any code or product or
        manipulate the content of the FlixLatino service in any way; or, use any
        data mining, data gathering or extraction method. In addition, you agree
        not to upload, post, e-mail or otherwise send or transmit any material
        designed to interrupt, destroy or limit the functionality of any
        computer software or hardware or telecommunications equipment associated
        with the FlixLatino service, including any software viruses or any other
        computer code, files or programs.
      </p>
      <p>4</p>
      <p>
        f.The availability of movies &amp; shows to watch will change from time
        to time, and from country to country. The quality of the display of the
        streaming movies &amp; shows may vary from computer to computer, and
        device to device, and may be affected by a variety of factors, such as
        your location, the bandwidth available through and/or speed of your
        Internet connection. HD availability is subject to your Internet service
        and device capabilities. Not all content is available in HD and not all
        plans allow you to receive HD content. A download speed of at least 5.0
        Mbps per stream is recommended to receive HD content, which is defined
        as 720p or better. You are responsible for all Internet access charges.
        Please check with your Internet provider for information on possible
        Internet data usage charges. FlixLatino makes no representations or
        warranties about the quality of your watching experience on your
        display. The time it takes to begin watching a movie or show will vary
        based on a number of factors, including your location, available
        bandwidth at the time, the movie or show you have selected and the
        configuration of your FlixLatino ready device.
      </p>
      <p>
        g.FlixLatino streaming software is developed by, or for, FlixLatino and
        is designed to enable streaming of content from FlixLatino through
        FlixLatino ready devices. This software may vary by device and medium,
        and functionalities may also differ between devices. BY USING OUR
        SERVICE, YOU ACKNOWLEDGE AND AGREE TO RECEIVE, WITHOUT FURTHER NOTICE OR
        PROMPTING, UPDATED VERSIONS OF THE FLIXLATINO AND RELATED THIRD-PARTY
        SOFTWARE. IF YOU DO NOT ACCEPT THE FOREGOING TERMS, DO NOT USE OUR
        SERVICE. WE DO NOT TAKE RESPONSIBILITY OR OTHERWISE WARRANT THE
        PERFORMANCE OF THESE DEVICES, INCLUDING THE CONTINUING COMPATIBILITY OF
        THE DEVICE WITH OUR SERVICE. By using our service, you agree to look
        solely to the entity that manufactured and/or sold you the device for
        any issues related to the device and its compatibility with the
        FlixLatino service. If your FlixLatino ready device is sold, lost or
        stolen, please deactivate the FlixLatino ready device. If you fail to
        log out or deactivate your device, subsequent users may access the
        FlixLatino service through your account and may be able to access
        certain of your account information. To deactivate a device, follow
        instructions on the "Your Account" page of our website.
      </p>
      <p>
        h.We may terminate or restrict your use of our service, without
        compensation or notice if you are, or if we suspect that you are (i) in
        violation of any of these Terms of Use or (ii) engaged in illegal or
        improper use of the service.
      </p>
      <p>
        i.FlixLatino Members are required to be eighteen (18) years of age or
        older. FlixLatino Members who are parents are responsible for deciding
        what content, if any, their children should be allowed to watch.
        FlixLatino provides parents with advisory ratings concerning the age
        appropriateness of its content.
      </p>
      <p>7.Passwords &amp; Account Access</p>
      <p>
        a.The member who created the FlixLatino account and whose Payment Method
        is charged is referred to here as the Account Owner. The Account Owner
        has access and control over the FlixLatino account. The Account Owner's
        control is exercised through use of the Account Owner's password and
        therefore to maintain exclusive control, the Account Owner should not
        reveal the password to anyone. In addition, if the Account Owner wishes
        to prohibit others from contacting FlixLatino Customer Service and
        potentially altering the Account Owner's control, the Account Owner
        should not reveal the Payment Method details (e.g., last four digits of
        their credit or debit card, or their email address if they use PayPal)
        associated with their account. You are responsible for updating and
        maintaining the truth and accuracy of the information you provide to us
        relating to your account.
      </p>
      <p>
        b.In order to provide you with ease of access to your account and to
        help administer the FlixLatino service, FlixLatino implements technology
        that enables us to recognize you as the Account Owner and provide you
        with direct access to your account without requiring you to retype any
        password or
      </p>
      <p>5</p>
      <p>
        other user identification when you revisit the FlixLatino service, which
        includes accessing via FlixLatino ready devices or website.
      </p>
      <p>
        c.You should be mindful of any communication requesting that you submit
        credit card or other account information. Providing your information in
        response to these types of communications can result in identity theft.
        Always access your sensitive account information by going directly to
        the FlixLatino website and not through a hyperlink in an email or any
        other electronic communication, even if it looks official. FlixLatino
        reserves the right to place any account on hold anytime with or without
        notification to the member in order to protect itself and its partners
        from what it believes to be fraudulent activity. FlixLatino is not
        obligated to credit or discount a membership for holds placed on the
        account by either a representative of FlixLatino or by the automated
        processes of FlixLatino.
      </p>
      <p>8.Disclaimers of Warranties and Limitations on Liability</p>
      <p>
        a.THE FLIXLATINO SERVICE AND ALL CONTENT AND SOFTWARE ASSOCIATED
        THEREWITH, OR ANY OTHER FEATURES OR FUNCTIONALITIES ASSOCIATED WITH THE
        FLIXLATINO SERVICE, ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITH ALL
        FAULTS AND WITHOUT WARRANTY OF ANY KIND. FLIXLATINO DOES NOT GUARANTEE,
        REPRESENT, OR WARRANT THAT YOUR USE OF THE FLIXLATINO SERVICE WILL BE
        UNINTERRUPTED OR ERROR-FREE. FLIXLATINO SPECIFICALLY DISCLAIMS LIABILITY
        FOR THE USE OF APPLICATIONS, FLIXLATINO READY DEVICES, AND FLIXLATINO
        SOFTWARE (INCLUDING THEIR CONTINUING COMPATIBILITY WITH OUR SERVICE).
      </p>
      <p>
        b.TO THE EXTENT PERMISSIBLE UNDER APPLICABLE LAWS, IN NO EVENT SHALL
        FLIXLATINO, OR ITS SUBSIDIARIES OR ANY OF THEIR SHAREHOLDERS, DIRECTORS,
        OFFICERS, EMPLOYEES OR LICENSORS BE LIABLE (JOINTLY OR SEVERALLY) TO YOU
        FOR PERSONAL INJURY OR ANY SPECIAL, INCIDENTAL, INDIRECT OR
        CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER.
      </p>
      <p>
        c.SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR
        THE LIMITATION OR EXCLUSION OF LIABILITY FOR CERTAIN TYPES OF DAMAGES.
        THEREFORE, SOME OF THE ABOVE LIMITATIONS IN THIS SECTION MAY NOT APPLY
        TO YOU. STATUTORY RIGHTS THAT APPLY TO YOU.
      </p>
      <p>
        d.NOTHING IN THESE TERMS OF USE SHALL AFFECT ANY NON-WAIVABLE STATUTORY
        RIGHTS THAT APPLY TO YOU. If any provision or provisions of these Terms
        of Use shall be held to be invalid, illegal, or unenforceable, the
        validity, legality and enforceability of the remaining provisions shall
        remain in full force and effect.
      </p>
      <p>9.Free Trials &amp; Promotions.</p>
      <p>
        a.In certain jurisdictions, gift cards for the FlixLatino service may be
        available for purchase at third-party retail outlets and websites, which
        can be redeemed on our website at the Create an Account link and enter
        the promotion code. From time to time, other types of promotional codes
        may be available, including those provided as part of a third party
        promotion. Promotional codes may be redeemed as described in the
        specifics of the promotion. Gift cards and promotional codes can only be
        used once, cannot be redeemed for cash, and may be combined with other
        offers, including a free trial, subject to certain restrictions as
        determined by FlixLatino in its sole discretion. If you received a
        promotional code through an offer by a third party, additional
        conditions may apply.
      </p>
      <p>
        b.The FlixLatino service may be made available to you on a free trial
        basis for a limited
      </p>
      <p>6</p>
      <p>
        time ("Trial Subscription"). The specific duration of the Trial
        Subscription will be specified in the applicable offer at sign-up. Trial
        Subscriptions are limited to new FlixLatino service subscribers, unless
        otherwise specified. These Terms of Use apply to any Trial Subscription,
        unless otherwise specified.
      </p>
      <p>
        c.At the time of signing up for a Trial Subscription, you must provide a
        valid Payment Method in order to use the FlixLatino service during the
        Trial Subscription period. Your Payment Method will not be charged by
        the Subscription Provider during the Trial Subscription Period.
      </p>
      <p>
        d.UPON THE EXPIRATION OF THE TRIAL SUBSCRIPTION, THE SUBSCRIPTION FEE
        FOR THE SERVICE WILL BE CHARGED TO YOUR PAYMENT METHOD, UNLESS YOU
        TIMELY CANCEL THE TRIAL SUBSCRIPTION. PLEASE NOTE THAT YOU WILL NOT BE
        NOTIFIED THAT YOUR TRIAL SUBSCRIPTION WILL END OR HAS ENDED. To find
        additional details about your Trial Subscription, including the date the
        Trial Subscription ends, please visit the My Account page in the
        FlixLatino site (www.flixlatino.com/myaccount) for the latest
        information contained in our records or contact your Subscription
        Provider directly.
      </p>
      <p>
        e.No refunds, adjustments or price protection will be applied to your
        Subscription Fee in the event of a new/subsequent discount or
        promotional offering after you sign-up for the FlixLatino service. New
        customers may take advantage of any "new customer" promotion only once.
        Requirements for a special promotion will be stated at the time each
        offer is presented. As a condition of these Terms of Use, you agree not
        to register multiple times for the same promotional offer using multiple
        names, addresses, email addresses or other means. Any such action shall
        constitute a violation of these Terms of Use and may result in the
        termination of your Registered Account.
      </p>
      <p>10.Intellectual Property</p>
      <p>
        a.Copyright. The FlixLatino service, including all content provided on
        the FlixLatino service, is protected by copyright, trade secret or other
        intellectual property laws and treaties.
      </p>
      <p>
        b.Trademarks. FlixLatino is a registered trademark of Somos Next, LLC.
      </p>
      <p>11.Governing Law</p>
      <p>
        a.For all FlixLatino members, these Terms of Use shall be governed by
        and construed in accordance with the laws of the state of Florida,
        U.S.A. without regard to conflict of laws provisions.
      </p>
      <p>
        b.You may also be entitled to certain consumer protection rights under
        the laws of your jurisdiction.
      </p>
      <p>
        12.Applications. You may encounter third-party applications (including,
        without limitation, websites, widgets, software, or other software
        utilities) ("Application(s)") that interact with the FlixLatino service.
        These Applications may import data related to your FlixLatino account
        and activity and otherwise gather data from you. These Applications are
        provided solely as a convenience to you, and FlixLatino is not
        responsible for such Applications. SUCH APPLICATIONS ARE OWNED OR
        OPERATED BY THIRD PARTIES THAT ARE NOT RELATED TO WITH OR SPONSORED BY
        FLIXLATINO AND MAY NOT BE AUTHORIZED FOR USE WITH OUR SERVICE IN ALL
        COUNTRIES. USE OF AN APPLICATION IS AT YOUR OWN OPTION AND RISK.
      </p>
      <p>
        13. Hyperlinks To And From Third Party Sites. (a)The Service may link
        you to other sites on the Internet including, without limitation, sites
        owned
      </p>
      <p>7</p>
      <p>
        or controlled by our providers. These sites may contain information or
        material that some people may find inappropriate or offensive. These
        other sites are not under the control of FlixLatino, and you acknowledge
        that (whether or not such sites are affiliated in any way with
        FlixLatino or its providers) FlixLatino is not responsible for the
        accuracy, copyright compliance, legality, decency, or any other aspect
        of the content of such sites. The inclusion of such a link does not
        imply endorsement of any site by FlixLatino or any association with its
        operators.
      </p>
      <p>
        (b)FlixLatino cannot ensure that you will be satisfied with any products
        or services that you purchase from any third-party site that links to or
        from the Service. FlixLatino does not endorse any of the merchandise,
        nor has FlixLatino taken any steps to confirm the accuracy or
        reliability of any of the information contained in such third-party
        sites. We have no duty to pre-screen information, products and services
        of third parties (collectively "Third-Party Content"), but we have the
        right to refuse to post or to edit submitted Third-Party Content. We
        reserve the right to remove Third-Party Content for any reason, but we
        are not responsible for any failure or delay in removing such material.
        FlixLatino does not make any representations or warranties as to the
        security of any information (including, without limitation, credit card
        and other personal information) you might be requested to give any third
        party, and you irrevocably waive any claim against us with respect to
        such sites. We strongly encourage you to make whatever investigation you
        feel necessary or appropriate before proceeding with any online
        transaction with any of these third parties.
      </p>
      <p>
        (c)Any area of the Service that is accessed through any third party
        proprietary online service is subject to the rules, policies and
        guidelines of such third party proprietary online service.
      </p>
      <p>
        14.Use of Information Submitted. FlixLatino is free to use any comments,
        information, ideas, concepts, reviews, or techniques or any other
        material contained in any communication you may send to us ("Feedback"),
        including responses to questionnaires or through postings to the
        FlixLatino service, including the FlixLatino website and user
        interfaces, worldwide and in perpetuity without further compensation,
        acknowledgement or payment to you for any purpose whatsoever including,
        but not limited to, developing, manufacturing and marketing products and
        creating, modifying or improving the FlixLatino service. In addition,
        you agree not to enforce any "moral rights" in and to the Feedback, to
        the extent permitted by applicable law. Please note FlixLatino does not
        accept unsolicited materials or ideas for movies or shows, and is not
        responsible for the similarity of any of its content or programming in
        any media to materials or ideas transmitted to FlixLatino. Should you
        send any unsolicited materials or ideas, you do so with the
        understanding that no additional consideration of any sort will be
        provided to you, and you are waiving any claim against FlixLatino and/or
        Somos Next, LLC and its affiliates regarding the use of such materials
        and ideas, even if material or an idea is used that is substantially
        similar to the material or idea you sent.
      </p>
      <p>
        15.Customer Support. To find more information about our service and its
        features, or if you need assistance with your account, please visit
        FlixLatino Help Center (www.flixlatino.com/helpcenter). In the event of
        any conflict between these Terms of Use and information provided by
        Customer Support or other portions of our website, these Terms of Use
        will control.
      </p>
      <p>16.Arbitration Agreement</p>
      <p>
        a. You and FlixLatino agree that any dispute, claim or controversy
        arising out of or relating in any way to the FlixLatino service, these
        Terms of Use and this Arbitration Agreement, shall be determined by
        binding arbitration or in small claims court. Arbitration is more
        informal than a lawsuit in court. Arbitration uses a neutral arbitrator
        instead of a judge or jury, allows for more limited discovery than in
        court, and is subject to very limited review by courts. Arbitrators can
        award the same damages and relief that a court can award. You agree
        that, by agreeing to these Terms of Use, the U.S. Federal Arbitration
        Act governs the interpretation and enforcement of this provision, and
        that you and FlixLatino are each waiving the right to a
      </p>
      <p>8</p>
      <p>
        trial by jury or to participate in a class action. This arbitration
        provision shall survive termination of this Agreement and the
        termination of your FlixLatino membership.
      </p>
      <p>
        b.If you elect to seek arbitration or file a small claim court action,
        you must first send to FlixLatino, by certified mail, a written Notice
        of your claim ("Notice"). The Notice to FlixLatino must be addressed to:
        General Counsel, Somos Next, LLC, 2601 S. Bayshore Drive, Suite 1250,
        Miami, FL 33133 ("Notice Address"). If FlixLatino initiates arbitration,
        it will send a written Notice to the email address used for your
        membership account. A Notice, whether sent by you or by FlixLatino, must
        (a) describe the nature and basis of the claim or dispute; and (b) set
        forth the specific relief sought ("Demand"). If FlixLatino and you do
        not reach an agreement to resolve the claim within 30 days after the
        Notice is received, you or FlixLatino may commence an arbitration
        proceeding or file a claim in small claims court.
      </p>
      <p>
        c.You may download or copy a form Notice and a form to initiate
        arbitration at www.adr.org. If you are required to pay a filing fee,
        after FlixLatino receives notice at the Notice Address that you have
        commenced arbitration, FlixLatino will promptly reimburse you for your
        payment of the filing fee, unless your claim is for greater than
        US$10,000.00, in which event you will be responsible for filing fees.
      </p>
      <p>
        d.The arbitration will be governed by the Commercial Arbitration Rules
        and the Supplementary Procedures for Consumer Related Disputes
        (collectively, "AAA Rules") of the American Arbitration Association
        ("AAA"), as modified by this Agreement, and will be administered by the
        AAA. The AAA Rules and Forms are available online at www.adr.org, by
        calling the AAA at 1-800-778-7879, or by writing to the Notice Address.
        The arbitrator is bound by the terms of this Agreement. All issues are
        for the arbitrator to decide, including issues relating to the scope and
        enforceability of this arbitration agreement. Unless FlixLatino and you
        agree otherwise, any arbitration hearings will take place in Miami,
        Florida.
      </p>
      <p>
        e.If your claim is for US$10,000.00 or less, we agree that you may
        choose whether the arbitration will be conducted solely on the basis of
        documents submitted to the arbitrator, through a telephonic hearing, or
        by an in-person hearing as established by the AAA Rules. If your claim
        exceeds US$10,000, the right to a hearing will be determined by the AAA
        Rules. Regardless of the manner in which the arbitration is conducted,
        the arbitrator shall issue a reasoned written decision sufficient to
        explain the essential findings and conclusions on which the award is
        based. If the arbitrator issues you an award that is greater than the
        value of FlixLatino’s last written settlement offer made before an
        arbitrator was selected (or if FlixLatino did not make a settlement
        offer before an arbitrator was selected), then FlixLatino will pay you
        the amount of the award or US$1,000.00, whichever is greater. Except as
        expressly set forth herein, the payment of all filing, administration
        and arbitrator fees will be governed by the AAA Rules.
      </p>
      <p>
        f.YOU AND FLIXLATINO AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER
        ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS
        MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. Further,
        unless both you and FlixLatino agree otherwise, the arbitrator may not
        consolidate more than one person's claims with your claims, and may not
        otherwise preside over any form of a representative or class proceeding.
        If this specific provision is found to be unenforceable, then the
        entirety of this arbitration provision shall be null and void. The
        arbitrator may award declaratory or injunctive relief only in favor of
        the individual party seeking relief and only to the extent necessary to
        provide relief warranted by that party's individual claim.
      </p>
      <p>
        17.Survival. If any provision or provisions of these Terms of Use shall
        be held to be invalid, illegal, or unenforceable, the validity, legality
        and enforceability of the remaining provisions shall remain in full
        force and effect.
      </p>
      <p>9</p>
      <p>
        18.Use in the United States Only. The FlixLatino service and/or Site are
        intended for viewing solely within the FlixLatino service area. Use of
        technology to mask your location or hinder FlixLatino’s ability to
        ascertain your location is prohibited. Please note FlixLatino may use
        technologies to verify your geographic location. FlixLatino makes no
        representation that materials or other Content in the FlixLatino service
        and/or Site are appropriate or available for use outside of the United
        States. By using the FlixLatino service and/or submitting personally
        identifiable information to the FlixLatino service, either during the
        registration process or subsequently, you consent to have your
        information transferred to and processed and maintained in the United
        States, subject to applicable U.S. laws.
      </p>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/functional/languages";
import MetaService from "@/services/MetaService";

export default {
  name: "TermsAndConditionsView",
  metaInfo: () => {
    return {
      title: i18n.global.t("termsAndConditions.meta.title"),
      htmlAttrs: { lang: i18n.global.locale },
      meta: [
        MetaService.robotIndex(),
        MetaService.description(
          i18n.global.t("termsAndConditions.meta.description")
        ),
      ],
    };
  },
  mounted() {
    this.$meta.canonicalUrls(
      this.$t("routes.terms_and_conditions", "es"),
      this.$t("routes.terms_and_conditions", "en")
    );
  },
};
</script>

<style scoped></style>
